import get from 'lodash/get';

const customerStatus = {
    in_progress: 'En cours - Notif. Quotidienne changement de status libre à reservé et vice-versa',
    standby: 'En veille - Notif. quotidienne uniquement pour les nouveaux lots et lots qui deviendraient dispo',
    processed: 'Traité - ABS de notif. suite à une Réservation',
    archived: 'Archivé - ABS de notif. suite à l\'archivage d\'un prospect',
};

const customerStatusMini = {
    in_progress: 'En cours',
    standby: 'En veille',
    processed: 'Traité',
    archived: 'Archivé',
};

const customerStatusColors = {
    in_progress: '#20d1d4',
    standby: '#fa9f43',
    processed: '#28c76f',
    archived: '#999999',
}

function formatCustomerStatus(value: string) {
    let status = get(customerStatus, value, value);

    return status.replace(/-.*/, '');
}

function getFullCustomerStatus(value: string) {
    let status = get(customerStatus, value, value);

    return status
}

export { customerStatus, customerStatusMini, formatCustomerStatus, getFullCustomerStatus, customerStatusColors };
